import React, { useState, useEffect } from 'react';
import ScaylorOrb from '../assets/images/ScaylorOrb.svg';

const SearchBar = ({ onSearch, selectedContextId, onSearchComplete, setLoading }) => {
  const [rotationDegree, setRotationDegree] = useState(0);
  const [momentum, setMomentum] = useState(0);
  const [lastTyped, setLastTyped] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    let animationFrame;
    const animate = () => {
      setRotationDegree(prev => prev + momentum);
      setMomentum(prev => {
        // Gradually reduce momentum
        const newMomentum = prev * 0.95;
        return Math.abs(newMomentum) < 0.1 ? 0 : newMomentum;
      });
      
      if (momentum !== 0) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [momentum]);

  const handleInputChange = (e) => {
    const now = Date.now();
    const timeDiff = now - lastTyped;
    const newMomentum = Math.min(20, 8 + (timeDiff < 200 ? 8 : 0));
    setMomentum(prev => prev + newMomentum);
    setLastTyped(now);
    setSearchQuery(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;

    const currentQuery = searchQuery;
    setSearchQuery(''); // Clear search input immediately when Enter is pressed

    const token = localStorage.getItem('token');
    if (!token) return;

    try {
      if (!selectedContextId) {
        console.error('No context selected');
        return;
      }

      // Set loading before making the API call
      setLoading(true);

      const query = await fetch(`${process.env.REACT_APP_API_URL}/api/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          content: currentQuery,
          contextId: selectedContextId
        }),
      });

      if (query.ok) {
        const data = await query.json();
        console.log('Chat API Response:', data);
        onSearchComplete(currentQuery); // Pass the search query to the callback
      } else {
        console.error('Failed to send chat message');
        setLoading(false); // Reset loading on error
      }
    } catch (error) {
      console.error('Error sending chat message:', error);
      setLoading(false); // Reset loading on error
    }
  };

  return (
    <div className="w-full max-w-3xl mx-auto">
      <form onSubmit={handleSubmit} className="relative flex items-center">
        <div className="absolute left-3 z-10">
          <img
            src={ScaylorOrb}
            alt="Scaylor Orb"
            style={{ 
              transform: `rotate(${rotationDegree}deg)`,
            }}
            className="w-6 h-6"
          />
        </div>
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleInputChange}
          className="w-full pl-12 pr-4 py-2 rounded-lg border border-gray-200 focus:outline-none focus:border-gray-400 bg-white shadow-sm"
        />
      </form>
    </div>
  );
};

export default SearchBar; 